<template>
  <transition name="slide-fade" >
      <div class="scroll-post__title-list"
           v-if="showSlideShow"
           >
        <ul class="title-list">
          <li v-for="slide in slides"
              :key="slide.id"
              :style="getListStyle(slide)"
              class="title-list__list">
            <cmslink :link="slide"/>
          </li>
        </ul>
      </div>
      </transition>
</template>

<script>

  export default {
    props: ['slides', 'getPercent', 'showSlideShow', 'scrollListener'],
    methods: {

      getListStyle(slide) {
        const height = 30;
        const {position, relativePosition, relativePositionFloat, numberOfSlides} = this.getPercent(slide);
        const pos = relativePosition < 0 ? relativePositionFloat + numberOfSlides : relativePositionFloat;
        let top = pos * height;
        let opacity = pos;
        const marginTop = relativePosition == 1 ? (relativePositionFloat - relativePosition) * 20 : 0;
        if (pos > 3) {
          opacity = 1 - 0.3 * (pos - 2);
        }
        const display = opacity <= 0 ? 'none' : undefined;
        return {
          order: relativePosition,
          opacity,
          marginTop: `${marginTop}px`,
          top: top + 'px',
        };
      },
    },
  };
</script>

